import { currentOfferingsByPlanType, PlanType } from '@/services/billing/plans';

// Greeting copy for the contracts-sales welcome message, keyed by the account's plan situation.
const GREETING = {
  legacy:
    "it looks like you're on an older plan and are interested in one of our newer plans! Great, we'd love to help you with that upgrade.",
  builder:
    "it looks like you're on our Builder plan and are interested in one of our other plans! Great, we'd love to help you with that upgrade.",
  trials: "it looks like you're interested in purchasing a plan! Great, we'd love to help you with that.",
  upgradeDowngradeRequest:
    "it looks like you're interested in changing your plan! Great, we'd love to help you with that.",
  enterprise: "it looks like you're interested in upgrading your plan! Great, we'd love to help you with that.",
};

type GreetingInputs = {
  isBuilder: boolean;
  isTrial: boolean;
  planType: PlanType | undefined;
  planClicked: PlanType | undefined;
};

/**
 * The contracts-sales welcome message, branched on the account's plan and the plan the user clicked.
 */
export function contractsSalesGreeting({ isBuilder, isTrial, planType, planClicked }: GreetingInputs): string {
  if (isBuilder) {
    return GREETING.builder;
  }
  if (isTrial) {
    return GREETING.trials;
  }
  if (currentOfferingsByPlanType.includes(planType ?? PlanType.NotReportable)) {
    return planClicked === PlanType.Enterprise ? GREETING.enterprise : GREETING.upgradeDowngradeRequest;
  }
  return GREETING.legacy;
}
